/*
 * Machine model finder — category-first.
 *
 * Default (enhanced) view shows machine-type tiles. Tapping one drills into a
 * bounded list of just those machines; "← All categories" returns. The search
 * box cuts across every type and takes over the list view while it has a value.
 *
 * Everything is server-rendered: the full card grid (with parts-page links) is
 * in the initial HTML for SEO and shows as-is with JS off. This script only
 * toggles visibility — it never fetches.
 */
(function () {
  function initSection(section) {
    var grid = section.querySelector("[data-machine-finder-grid]");
    if (!grid || grid.dataset.finderReady === "true") return;
    grid.dataset.finderReady = "true";

    var cards = Array.prototype.slice.call(
      grid.querySelectorAll("[data-machine-card]"),
    );
    var addCard = grid.querySelector("[data-machine-add]");
    var search = section.querySelector("[data-machine-finder-search]");
    var tiles = Array.prototype.slice.call(
      section.querySelectorAll("[data-machine-finder-tile]"),
    );
    var empty = section.querySelector("[data-machine-finder-empty]");
    var back = section.querySelector("[data-machine-finder-back]");
    var crumbLabel = section.querySelector("[data-machine-finder-crumb-label]");
    var crumbCount = section.querySelector("[data-machine-finder-crumb-count]");

    var activeCat = null; // null = categories view

    function cardCats(card) {
      return " " + (card.getAttribute("data-categories") || "") + " ";
    }

    function setView(view) {
      section.setAttribute("data-finder-view", view);
    }

    // Drill into a single category (no active search).
    function showCategory(cat, label) {
      activeCat = cat;
      if (search) search.value = "";
      if (back) back.hidden = false;
      if (crumbLabel) crumbLabel.textContent = label;
      setView("list");
      apply();
    }

    // Return to the tile grid.
    function showCategories() {
      activeCat = null;
      if (search) search.value = "";
      setView("categories");
      apply();
    }

    function apply() {
      var q = (search && search.value ? search.value : "").trim().toLowerCase();
      var searching = q.length > 0;
      var matched = 0;

      cards.forEach(function (card) {
        var inCat =
          searching ||
          (activeCat !== null &&
            cardCats(card).indexOf(" " + activeCat + " ") !== -1);
        var inSearch =
          !q || (card.getAttribute("data-search") || "").indexOf(q) !== -1;
        var pass = inCat && inSearch;
        card.hidden = !pass;
        if (pass) matched++;
      });

      // The add card shows in any list view — a drilled category OR search
      // results — but never in the tile (categories) grid.
      var inList = searching || activeCat !== null;
      if (addCard) addCard.hidden = !inList;

      // Empty message only belongs to the list view (a search/category with no
      // hits) — never the tile grid, where 0 cards match by design.
      if (empty) empty.hidden = !inList || matched !== 0;

      // Breadcrumb: search results vs. a named category.
      if (searching) {
        if (back) back.hidden = true;
        if (crumbLabel) crumbLabel.textContent = "Results for “" + q + "”";
      } else if (activeCat !== null) {
        if (back) back.hidden = false;
      }
      if (crumbCount) crumbCount.textContent = matched;
    }

    // Search drives the view: any text → list (cross-category); cleared → back to
    // the open category, or the tile grid if none was open.
    if (search) {
      search.addEventListener("input", function () {
        var q = search.value.trim();
        if (q) {
          setView("list");
          apply();
        } else if (activeCat !== null) {
          // Re-show the category we were in.
          setView("list");
          if (back) back.hidden = false;
          apply();
        } else {
          setView("categories");
          apply();
        }
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener("click", function () {
        showCategory(
          tile.getAttribute("data-category"),
          tile.getAttribute("data-label") || "",
        );
      });
    });

    if (back) {
      back.addEventListener("click", showCategories);
    }

    // Enhance: switch from the server-rendered full grid to the tile view.
    section.classList.add("is-enhanced");
    setView("categories");
    apply();
  }

  function initAll(context) {
    var sections = (context || document).querySelectorAll(".machine-finder");
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
